(function () {

  /*
   * V2 intentionally gives us a fresh session state
   * after rebuilding the onboarding hint.
   */
  const MEASUREMENT_HINT_SESSION_KEY =
    'zb-size-guide-measurement-hint-seen-v2';

  const SVG_NS = 'http://www.w3.org/2000/svg';


  function initializeSizeGuide(root) {

    if (
      !root ||
      root.dataset.zbSizeGuideInitialized === 'true'
    ) {
      return;
    }

    root.dataset.zbSizeGuideInitialized = 'true';


    const openButton = root.querySelector(
      '[data-zb-size-guide-open]'
    );

    const dialog = root.querySelector(
      '[data-zb-size-guide-dialog]'
    );

    const closeButton = root.querySelector(
      '[data-zb-size-guide-close]'
    );


    /*
     * Supports both versions of the ZB markup.
     */
    const unitButtons = root.querySelectorAll(
      '[data-zb-size-unit], [data-zb-unit]'
    );

    const unitPanels = root.querySelectorAll(
      '[data-zb-size-panel], [data-zb-table]'
    );


    if (!openButton || !dialog) {
      return;
    }


    /* ========================================================
       CREATE HINT IF IT IS MISSING FROM LIQUID
       ======================================================== */

    function ensureMeasurementHint() {

      let existingHint = root.querySelector(
        '[data-zb-measure-hint]'
      );

      if (existingHint) {
        return existingHint;
      }


      const overlay = root.querySelector(
        '.zb-measurement-overlay'
      );

      if (!overlay) {
        return null;
      }


      const chestLine =
        overlay.querySelector(
          '.zb-measurement-line[data-zb-measure="chest"] .zb-measurement-line__visual'
        ) ||
        overlay.querySelector(
          '.zb-measurement-line[data-zb-measure="chest"] line'
        );


      if (!chestLine) {
        return null;
      }


      /*
       * Calculate the exact middle of the existing CHEST line,
       * so the hint stays correct even if we move the line later.
       */

      const x1 = parseFloat(
        chestLine.getAttribute('x1')
      );

      const x2 = parseFloat(
        chestLine.getAttribute('x2')
      );

      const y1 = parseFloat(
        chestLine.getAttribute('y1')
      );

      const y2 = parseFloat(
        chestLine.getAttribute('y2')
      );


      if (
        !Number.isFinite(x1) ||
        !Number.isFinite(x2) ||
        !Number.isFinite(y1) ||
        !Number.isFinite(y2)
      ) {
        return null;
      }


      const centerX = (x1 + x2) / 2;
      const centerY = (y1 + y2) / 2;


      const hint = document.createElementNS(
        SVG_NS,
        'g'
      );

      hint.classList.add(
        'zb-measurement-hint'
      );

      hint.setAttribute(
        'data-zb-measure-hint',
        'chest'
      );

      hint.setAttribute(
        'tabindex',
        '0'
      );

      hint.setAttribute(
        'role',
        'button'
      );

      hint.setAttribute(
        'aria-label',
        'Explore chest measurement'
      );


      /* Soft pulse */

      const pulse =
        document.createElementNS(
          SVG_NS,
          'circle'
        );

      pulse.classList.add(
        'zb-measurement-hint__pulse'
      );

      pulse.setAttribute(
        'cx',
        centerX
      );

      pulse.setAttribute(
        'cy',
        centerY
      );

      pulse.setAttribute(
        'r',
        '30'
      );


      /* Solid pink dot */

      const dot =
        document.createElementNS(
          SVG_NS,
          'circle'
        );

      dot.classList.add(
        'zb-measurement-hint__dot'
      );

      dot.setAttribute(
        'cx',
        centerX
      );

      dot.setAttribute(
        'cy',
        centerY
      );

      dot.setAttribute(
        'r',
        '8'
      );


      hint.appendChild(pulse);
      hint.appendChild(dot);

      overlay.appendChild(hint);


      return hint;
    }


    const measurementHint =
      ensureMeasurementHint();


    /* ========================================================
       OPEN / CLOSE
       ======================================================== */

    let lastFocusedElement = null;

    let savedScrollX = 0;
    let savedScrollY = 0;


    function openDialog() {

      /*
       * IMPORTANT:
       * This may be the small ruler button near
       * CHOOSE YOUR ZB SIZE.
       *
       * We save the ACTUAL focused element,
       * not necessarily the lower SIZE & FIT trigger.
       */

      if (
        document.activeElement &&
        document.activeElement instanceof HTMLElement
      ) {

        lastFocusedElement =
          document.activeElement;

      } else {

        lastFocusedElement = null;

      }


      savedScrollX = window.scrollX;
      savedScrollY = window.scrollY;


      showMeasurementHintIfNeeded();


      if (
        typeof dialog.showModal === 'function'
      ) {

        dialog.showModal();

      } else {

        dialog.setAttribute(
          'open',
          ''
        );

      }

    }


    function restorePagePosition() {

      window.scrollTo({
        left: savedScrollX,
        top: savedScrollY,
        behavior: 'auto'
      });

    }


    function closeDialog() {

      const returnFocusElement =
        lastFocusedElement;

      const returnScrollX =
        savedScrollX;

      const returnScrollY =
        savedScrollY;


      /*
       * Remove focus from anything inside the dialog first.
       * This helps prevent native <dialog> focus restoration
       * from moving the page before we restore it ourselves.
       */

      if (
        document.activeElement &&
        dialog.contains(document.activeElement) &&
        document.activeElement instanceof HTMLElement
      ) {

        document.activeElement.blur();

      }


      if (
        typeof dialog.close === 'function'
      ) {

        dialog.close();

      } else {

        dialog.removeAttribute(
          'open'
        );

      }


      /*
       * Restore immediately...
       */

      window.scrollTo({
        left: returnScrollX,
        top: returnScrollY,
        behavior: 'auto'
      });


      /*
       * ...and again after the browser has completed
       * its native dialog closing/focus work.
       */

      requestAnimationFrame(function () {

        window.scrollTo({
          left: returnScrollX,
          top: returnScrollY,
          behavior: 'auto'
        });


        if (
          returnFocusElement &&
          returnFocusElement.isConnected
        ) {

          try {

            returnFocusElement.focus({
              preventScroll: true
            });

          } catch (error) {

            /*
             * Deliberately do NOT use normal focus()
             * as fallback because it may scroll the page.
             */

          }

        }


        window.scrollTo({
          left: returnScrollX,
          top: returnScrollY,
          behavior: 'auto'
        });


        requestAnimationFrame(function () {

          window.scrollTo({
            left: returnScrollX,
            top: returnScrollY,
            behavior: 'auto'
          });

        });

      });

    }


    /* ========================================================
       CM / IN
       ======================================================== */

    function getButtonUnit(button) {

      return (
        button.dataset.zbSizeUnit ||
        button.dataset.zbUnit ||
        ''
      );

    }


    function getPanelUnit(panel) {

      return (
        panel.dataset.zbSizePanel ||
        panel.dataset.zbTable ||
        ''
      );

    }


    function setUnit(unit) {

      unitButtons.forEach(
        function (button) {

          const isActive =
            getButtonUnit(button) === unit;


          button.classList.toggle(
            'is-active',
            isActive
          );


          button.setAttribute(
            'aria-pressed',
            isActive ? 'true' : 'false'
          );

        }
      );


      unitPanels.forEach(
        function (panel) {

          panel.hidden =
            getPanelUnit(panel) !== unit;

        }
      );

    }


    /* ========================================================
       MEASUREMENT SYSTEM
       ======================================================== */

    const measurementTargets =
      Array.from(
        root.querySelectorAll(
          '[data-zb-measure]'
        )
      );


    const hasFinePointer =
      window.matchMedia(
        '(hover: hover) and (pointer: fine)'
      ).matches;


    let pinnedMeasurement = null;
    let keyboardInteraction = false;


    function highlightMeasurement(
      measurement
    ) {

      measurementTargets.forEach(
        function (element) {

          const matches =
            element.dataset.zbMeasure ===
            measurement;


          element.classList.toggle(
            'is-zb-measure-active',
            matches
          );

        }
      );

    }


    function clearMeasurement() {

      measurementTargets.forEach(
        function (element) {

          element.classList.remove(
            'is-zb-measure-active'
          );

        }
      );

    }


    function restorePinnedMeasurement() {

      if (pinnedMeasurement) {

        highlightMeasurement(
          pinnedMeasurement
        );

      } else {

        clearMeasurement();

      }

    }


    /* ========================================================
       ONE TIME PER SESSION HINT
       ======================================================== */

    function hasSeenMeasurementHint() {

      try {

        return (
          sessionStorage.getItem(
            MEASUREMENT_HINT_SESSION_KEY
          ) === 'true'
        );

      } catch (error) {

        return false;

      }

    }


    function markMeasurementHintSeen() {

      try {

        sessionStorage.setItem(
          MEASUREMENT_HINT_SESSION_KEY,
          'true'
        );

      } catch (error) {

        /*
         * Size guide still works if storage
         * happens to be unavailable.
         */

      }

    }


    function hideMeasurementHint(
      rememberForSession
    ) {

      if (!measurementHint) {
        return;
      }


      measurementHint.classList.add(
        'is-hidden'
      );


      if (rememberForSession) {

        markMeasurementHintSeen();

      }

    }


    function showMeasurementHintIfNeeded() {

      if (!measurementHint) {
        return;
      }


      if (hasSeenMeasurementHint()) {

        measurementHint.classList.add(
          'is-hidden'
        );

      } else {

        measurementHint.classList.remove(
          'is-hidden'
        );

      }

    }


    function measurementInteractionDiscovered() {

      hideMeasurementHint(true);

    }


    /*
     * Correct initial state while dialog is closed.
     */

    showMeasurementHintIfNeeded();


    /* ========================================================
       KEYBOARD / POINTER DETECTION
       ======================================================== */

    document.addEventListener(
      'keydown',
      function (event) {

        if (
          event.key === 'Tab' ||
          event.key === 'ArrowLeft' ||
          event.key === 'ArrowRight' ||
          event.key === 'ArrowUp' ||
          event.key === 'ArrowDown'
        ) {

          keyboardInteraction = true;

        }

      }
    );


    document.addEventListener(
      'pointerdown',
      function () {

        keyboardInteraction = false;

      }
    );


    /* ========================================================
       NORMAL INTERACTIVE TARGETS

       LINE
       TEXT
       TABLE ROW
       ======================================================== */

    measurementTargets.forEach(
      function (target) {

        const measurement =
          target.dataset.zbMeasure;


        /* ---------------- DESKTOP HOVER ---------------- */

        target.addEventListener(
          'pointerenter',
          function (event) {

            if (
              event.pointerType === 'mouse' ||
              hasFinePointer
            ) {

              measurementInteractionDiscovered();

              highlightMeasurement(
                measurement
              );

            }

          }
        );


        target.addEventListener(
          'pointerleave',
          function (event) {

            if (
              event.pointerType === 'mouse' ||
              hasFinePointer
            ) {

              restorePinnedMeasurement();

            }

          }
        );


        /* ---------------- KEYBOARD FOCUS ---------------- */

        target.addEventListener(
          'focus',
          function () {

            if (!keyboardInteraction) {
              return;
            }


            measurementInteractionDiscovered();

            highlightMeasurement(
              measurement
            );

          }
        );


        target.addEventListener(
          'blur',
          function () {

            if (!keyboardInteraction) {
              return;
            }


            restorePinnedMeasurement();

          }
        );


        /* ---------------- MOBILE TAP ---------------- */

        target.addEventListener(
          'click',
          function (event) {

            /*
             * Desktop:
             * Hover performs the interaction.
             */

            if (hasFinePointer) {
              return;
            }


            event.preventDefault();


            measurementInteractionDiscovered();


            if (
              pinnedMeasurement ===
              measurement
            ) {

              pinnedMeasurement = null;

              clearMeasurement();

            } else {

              pinnedMeasurement =
                measurement;

              highlightMeasurement(
                measurement
              );

            }

          }
        );


        /* ---------------- ENTER / SPACE ---------------- */

        target.addEventListener(
          'keydown',
          function (event) {

            if (
              event.key !== 'Enter' &&
              event.key !== ' '
            ) {
              return;
            }


            event.preventDefault();


            measurementInteractionDiscovered();


            if (
              pinnedMeasurement ===
              measurement
            ) {

              pinnedMeasurement = null;

              clearMeasurement();

            } else {

              pinnedMeasurement =
                measurement;

              highlightMeasurement(
                measurement
              );

            }

          }
        );

      }
    );


    /* ========================================================
       PULSING PINK HINT
       ======================================================== */

    if (measurementHint) {

      const hintMeasurement =
        measurementHint.dataset.zbMeasureHint ||
        'chest';


      /*
       * DESKTOP
       *
       * Hover dot:
       * 1. Activate Chest everywhere.
       * 2. Remove dot.
       * 3. Remember discovery for this session.
       */

      measurementHint.addEventListener(
        'pointerenter',
        function (event) {

          if (
            event.pointerType !== 'mouse' &&
            !hasFinePointer
          ) {
            return;
          }


          highlightMeasurement(
            hintMeasurement
          );


          measurementInteractionDiscovered();

        }
      );


      /*
       * MOBILE TAP
       */

      measurementHint.addEventListener(
        'click',
        function (event) {

          if (hasFinePointer) {

            highlightMeasurement(
              hintMeasurement
            );

            measurementInteractionDiscovered();

            return;

          }


          event.preventDefault();
          event.stopPropagation();


          measurementInteractionDiscovered();


          pinnedMeasurement =
            hintMeasurement;


          highlightMeasurement(
            hintMeasurement
          );

        }
      );


      /*
       * KEYBOARD
       */

      measurementHint.addEventListener(
        'keydown',
        function (event) {

          if (
            event.key !== 'Enter' &&
            event.key !== ' '
          ) {
            return;
          }


          event.preventDefault();


          pinnedMeasurement =
            hintMeasurement;


          highlightMeasurement(
            hintMeasurement
          );


          measurementInteractionDiscovered();

        }
      );

    }


    /* ========================================================
       DIALOG EVENTS
       ======================================================== */

    openButton.addEventListener(
      'click',
      openDialog
    );


    if (closeButton) {

      closeButton.addEventListener(
        'click',
        closeDialog
      );

    }


    /*
     * Click outside white panel.
     */

    dialog.addEventListener(
      'click',
      function (event) {

        if (event.target === dialog) {

          closeDialog();

        }

      }
    );


    /*
     * ESC.
     */

    dialog.addEventListener(
      'cancel',
      function (event) {

        event.preventDefault();

        closeDialog();

      }
    );


    /*
     * Reset selected measurement when dialog closes.
     * Do NOT reset onboarding session state.
     */

    dialog.addEventListener(
      'close',
      function () {

        pinnedMeasurement = null;

        clearMeasurement();

      }
    );


    /* ========================================================
       UNIT EVENTS
       ======================================================== */

    unitButtons.forEach(
      function (button) {

        button.addEventListener(
          'click',
          function () {

            setUnit(
              getButtonUnit(button)
            );

          }
        );

      }
    );

  }


  /* ==========================================================
     INITIALIZE ALL
     ========================================================== */

  function initializeAllSizeGuides() {

    document
      .querySelectorAll(
        '[data-zb-size-guide]'
      )
      .forEach(
        initializeSizeGuide
      );

  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initializeAllSizeGuides
    );

  } else {

    initializeAllSizeGuides();

  }


  document.addEventListener(
    'shopify:section:load',
    initializeAllSizeGuides
  );

})();